import {
  PROCESS_TRANSFER_SERVICE_SUCCESS,
  PROCESS_TRANSFER_SERVICE_FAIL,
  PROCESS_TRANSFER_SERVICE_START,
  PROCESS_TRANSFER_SERVICE_INSERTED,
  PROCESS_TRANSFER_SERVICE_DELETED,
  PROCESS_TRANSFER_SERVICE_UPDATED,
  PROCESS_TRANSFER_SERVICE_CLEAR,
  PROCESS_TRANSFER_SEARCH_TEXT_UPDATE,
} from "../Actions/types"
import { convertIntif } from "@project/sharedcomponents/utilityFunctions"
import { DatetoDMY } from "@project/sharedcomponents/utilityFunctions"
import { getdropdownvalue, setColumnDataFilterWise, setOrderFilterWise } from "@project/components/utilityFunctions"
const INITIAL_STATE = {
  error: "",
  loading: false,
  data: [],
  totalcount: 0,
  rowsPerPage: 0,
  page: 0,
  order: "",
  norecord: false,
  orderBy: "",
  search_text: "",
  deleted: false,
  columnData: [
    { id: "code", numeric: false, visible: true, label: "Code", width: 100 },
    { id: "b_date", numeric: false, visible: true, label: "Date", width: 125 },
    { id: "partyname", numeric: false, visible: true, label: "Name" },
    { id: "name", numeric: false, visible: true, label: "Process", width: 250 },
    { id: "totQty", numeric: true, visible: true, label: "Quantity", width: 150, format: "qty_decimal" },
  ],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROCESS_TRANSFER_SERVICE_START:
      return { ...state, loading: true, error: "" }
    case PROCESS_TRANSFER_SERVICE_CLEAR:
      return { ...INITIAL_STATE }
    case PROCESS_TRANSFER_SERVICE_SUCCESS:
      if (action.page === 0) {
        var updatedcoloumn = setColumnDataFilterWise({ data: action.payload.data, columnData: state.columnData })
        action = setOrderFilterWise(action)
        return {
          ...state,
          columnData: updatedcoloumn,
          data: action.payload.data.result,
          totalcount: action.payload.data.total_count,
          rowsPerPage: action.rowsPerPage,
          page: action.page,
          order: action.order,
          orderBy: action.orderBy,
          islogin: true,
          norecord: action.payload.data.result.length === 0,
        }
      } else {
        return {
          ...state,
          data: action.payload.data.result,
          totalcount: action.payload.data.total_count,
          rowsPerPage: action.rowsPerPage,
          page: action.page,
          order: action.order,
          orderBy: action.orderBy,
          islogin: true,
          norecord: action.payload.data.result.length === 0,
        }
      }
    case PROCESS_TRANSFER_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
        data: [],
        loading: false,
        totalcount: 0,
        rowsPerPage: action.rowsPerPage,
        page: action.page,
        order: action.order,
        orderBy: action.orderBy,
        search_text: action.search_text,
      }
    case PROCESS_TRANSFER_SEARCH_TEXT_UPDATE:
      return { ...state, search_text: action.search_text, norecord: false }
    case PROCESS_TRANSFER_SERVICE_INSERTED:
      const inserteditem = {}
      inserteditem.code = action.insert_data.insert_code
      inserteditem.billno = action.insert_data.docno
      inserteditem.b_date = DatetoDMY(action.payload.InvoiceDate)
      inserteditem.name = getdropdownvalue({ formValues: action.payload, field: "toProcessSelectedValue", prop: "name" })
      inserteditem.processCode = getdropdownvalue({ formValues: action.payload, field: "toProcessSelectedValue", prop: "code" })
      inserteditem.partyname = getdropdownvalue({ formValues: action.payload, field: "supplierSelectedValue", prop: "name" })
      inserteditem.totQty = action.payload.tot_qty
      inserteditem.flag = "Lock"
      return { ...state, data: [inserteditem, ...state.data] }
    case PROCESS_TRANSFER_SERVICE_DELETED:
      if (action.otherDetail === "multi_delete") {
        var finalData = []
        var applyToDelete = action.payload.code.codes.map((a) => a.toString())
        if (action.response.data.meta.code === 403) {
          //Error
          var NotDelete = action.response.data.meta.message.map((a) => a.code.toString())
          finalData = state.data.filter((item) => {
            item.code = item.code.toString()
            if (!(applyToDelete.includes(item.code) && !NotDelete.includes(item.code))) {
              return item
            }
            return false
          })
        } //All delete
        else {
          finalData = state.data.filter((item) => {
            item.code = item.code.toString()
            if (!applyToDelete.includes(item.code)) {
              return item
            }
            return false
          })
        }
        return { ...state, data: finalData, deleted: !state.deleted }
      } else {
        return { ...state, data: state.data.filter((item) => item.code.toString() !== action.payload.code.toString()), deleted: !state.deleted }
      }
    case PROCESS_TRANSFER_SERVICE_UPDATED:
      let updateddata = state.data.map((item, index) => {
        if (convertIntif(item.code) !== convertIntif(action.payload.update_code)) {
          return item
        }
        const updateditem = { ...item }
        updateditem.code = action.payload.update_code
        updateditem.billno = action.payload.transfer_billNo
        updateditem.b_date = DatetoDMY(action.payload.InvoiceDate)
        updateditem.name = getdropdownvalue({ formValues: action.payload, field: "toProcessSelectedValue", prop: "name" })
        updateditem.processCode = getdropdownvalue({ formValues: action.payload, field: "toProcessSelectedValue", prop: "code" })
        updateditem.partyname = getdropdownvalue({ formValues: action.payload, field: "supplierSelectedValue", prop: "name" })
        updateditem.totQty = action.payload.tot_qty
        updateditem.flag = "Lock"
        return updateditem
      })
      return { ...state, data: updateddata }

    default:
      return state
  }
}
